import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  listItemHeader: {
    padding: '20px 20px 30px 20px'
  },
  navList: {
    paddingBottom: 5
  },
  navListItem: {
    padding: '20px 20px 20px 20px'
  },
  iconStyle: {
    alignItems: 'center'
  }
});
